import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, of, switchMap, take } from 'rxjs';
import * as fromGenerated from '../../_generated';
import { AssistantsActions } from './store/assistants.actions';
import { assistantsFeature, AssistantsState } from './store/assistants.reducer';

export const assistantsResolver: ResolveFn<
  fromGenerated.AssistantView[]
> = () => {
  const assistantsStore = inject<Store<AssistantsState>>(Store);

  if (assistantsStore.selectSignal(assistantsFeature.selectLoaded)()) {
    return of(assistantsStore.selectSignal(assistantsFeature.selectAll)());
  }

  assistantsStore.dispatch(AssistantsActions.loadAssistants());

  return assistantsStore.select(assistantsFeature.selectLoaded).pipe(
    filter((loaded) => loaded),
    take(1),
    switchMap(() => assistantsStore.select(assistantsFeature.selectAll)),
  );
};
